function Directive() {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      element.bind('keydown', function(e) {
        if (e.which === 13) {
          scope.$apply(function() {
            scope.$eval(attrs.ngEnter, {
              e
            });
          });

          e.preventDefault();
        }
      });
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/ngEnter/index.js